// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myDiagramDiv {
  background: whitesmoke;
  width: 80%;
  height: 400px;
}


.stacked{
  top:0;
  transition: top ease 0.3s;
  position:relative;
  right:2px;
}
.stacked:hover {
  top: -10px;
}


.ticket {
  transition: all 0.4s ease-in-out;
}
.ticket:hover {
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);
}

.ticket-row {
  border-color:#edeff1;
  border-style: dashed;
  border:1px dashed #edeff1;
  transition: all 0.2s ease-in-out;
  vertical-align: center;

}

.ticket-row:hover{
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.ticket-table {
  width:90%;
  margin:auto;
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.app_global_search{
  width: 320px;
  .search_input{
    font-size: 0.70rem;
  }
  .search_btn{
    width: 125px;
    font-size: 12px;
  }
}

.rounded-checkbox {
  border-radius: 50%!important;
  height:1rem!important;
  width:1rem!important;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
}

.rounded-checkbox:checked {
  background-color: #ff4613;
}


.modal-big {
  width:1200px;
}



.custom-window-class > .modal-dialog,
.custom-window-class > .modal-dialog > .modal-content {
  width: 1200px!important;
  max-width: 1200px!important;
  min-width: 1200px!important;
}










.tab {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.tab:after {
  content: '';
  display: block;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  position: absolute;
  background-color: #ff4612;
  transition: transform ease 200ms, opacity ease 0ms 200ms;
  transform: translateX(100%);
  opacity: 0;
}
.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {
  transform: translateX(-100%);
}
.tabs-wrapper:not(:hover) .tab:not(.active)::after {
  transform: translateY(100%);
}
.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {
  transition-delay: 0ms, 0ms;
}
.tab.active::after, .tab:hover::after {
  transform: translateX(0%);
  opacity: 1;
}

p.tab {
  display: inline-block;
  text-decoration: none;
  color: #000;
  padding: 1rem;
}



.avatar-box{
  display:table-cell;
  vertical-align:middle;

}
.avatar {
  display: table-cell;
  vertical-align:middle;
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  color: #fff;
}

.avatar-sm{
  width:2vw;
  height:2vw;
  font-size:1vw;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/ticketing/components/workflows/create-workflow-component/create-workflow-component.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,UAAU;EACV,aAAa;AACf;;;AAGA;EACE,KAAK;EACL,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;;AAExB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,YAAY;AACd;;;;AAIA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;;;;;;;;;;AAWA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;EACxD,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;;;AAIA;EACE,kBAAkB;EAClB,qBAAqB;;AAEvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA,g+JAAg+J","sourcesContent":[".myDiagramDiv {\n  background: whitesmoke;\n  width: 80%;\n  height: 400px;\n}\n\n\n.stacked{\n  top:0;\n  transition: top ease 0.3s;\n  position:relative;\n  right:2px;\n}\n.stacked:hover {\n  top: -10px;\n}\n\n\n.ticket {\n  transition: all 0.4s ease-in-out;\n}\n.ticket:hover {\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);\n}\n\n.ticket-row {\n  border-color:#edeff1;\n  border-style: dashed;\n  border:1px dashed #edeff1;\n  transition: all 0.2s ease-in-out;\n  vertical-align: center;\n\n}\n\n.ticket-row:hover{\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.ticket-table {\n  width:90%;\n  margin:auto;\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.app_global_search{\n  width: 320px;\n  .search_input{\n    font-size: 0.70rem;\n  }\n  .search_btn{\n    width: 125px;\n    font-size: 12px;\n  }\n}\n\n.rounded-checkbox {\n  border-radius: 50%!important;\n  height:1rem!important;\n  width:1rem!important;\n  border: 1px solid #ddd;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n}\n\n.rounded-checkbox:checked {\n  background-color: #ff4613;\n}\n\n\n.modal-big {\n  width:1200px;\n}\n\n\n\n.custom-window-class > .modal-dialog,\n.custom-window-class > .modal-dialog > .modal-content {\n  width: 1200px!important;\n  max-width: 1200px!important;\n  min-width: 1200px!important;\n}\n\n\n\n\n\n\n\n\n\n\n.tab {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n.tab:after {\n  content: '';\n  display: block;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  position: absolute;\n  background-color: #ff4612;\n  transition: transform ease 200ms, opacity ease 0ms 200ms;\n  transform: translateX(100%);\n  opacity: 0;\n}\n.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {\n  transform: translateX(-100%);\n}\n.tabs-wrapper:not(:hover) .tab:not(.active)::after {\n  transform: translateY(100%);\n}\n.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {\n  transition-delay: 0ms, 0ms;\n}\n.tab.active::after, .tab:hover::after {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\np.tab {\n  display: inline-block;\n  text-decoration: none;\n  color: #000;\n  padding: 1rem;\n}\n\n\n\n.avatar-box{\n  display:table-cell;\n  vertical-align:middle;\n\n}\n.avatar {\n  display: table-cell;\n  vertical-align:middle;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 600;\n  color: #fff;\n}\n\n.avatar-sm{\n  width:2vw;\n  height:2vw;\n  font-size:1vw;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
